import { faInbox } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import PageStyles from "./Page.styles";
import { INoResultsProps, DefaultTemplateProps } from "./Page.types";
import PageUtils from "./Page.utils";

const NO_RESULTS: React.FC<INoResultsProps> = (props: INoResultsProps) => {
  const { isSearch } = props;
  return (
    <PageStyles.NoResultsContainer className="no-results-container">
      <div>
        <div className="number-badge">
          <span>0</span>
        </div>
        <FontAwesomeIcon
          className="no-results-icon"
          icon={faInbox}
          size="10x"
          color="#666666"
        />
      </div>

      <h4>{PageUtils.getNoResultsHeader(isSearch)}</h4>
      {!isSearch && (
        <p className="no-projects-subheader-link">
          <a
            href="https://www.consumersenergy.com/residential/programs-and-services/service-connection"
            target="_blank"
            rel="noreferrer"
          >
            Need to add or modify Service?
          </a>
        </p>
      )}
      <hr />
      {!isSearch && (
        <p className="no-projects-subheader">Not Seeing Your Project?</p>
      )}
      <p>{PageUtils.getNoResultsMessage(isSearch)}</p>
    </PageStyles.NoResultsContainer>
  );
};

NO_RESULTS.defaultProps = DefaultTemplateProps;
export default NO_RESULTS;
